var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCloudBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.70764 12.4113L9.25161 14.9553M9.25161 14.9553L11.7956 12.4113M9.25161 14.9553V9.23133M14.8992 13.1045C15.4521 12.7157 15.8668 12.1608 16.083 11.5204C16.2992 10.8799 16.3056 10.1872 16.1015 9.54286C15.8973 8.89848 15.4931 8.33591 14.9476 7.93681C14.402 7.53771 13.7435 7.32283 13.0676 7.32336H12.2662C12.0749 6.5779 11.717 5.88554 11.2194 5.29841C10.7219 4.71129 10.0976 4.24469 9.39357 3.93375C8.68956 3.62281 7.92419 3.47563 7.15508 3.50329C6.38596 3.53095 5.63314 3.73272 4.95329 4.09343C4.27344 4.45414 3.68428 4.96437 3.23016 5.58572C2.77604 6.20707 2.46879 6.92335 2.33155 7.68063C2.19431 8.4379 2.23065 9.21645 2.43784 9.95765C2.64502 10.6988 3.01766 11.3834 3.52769 11.9597",
    stroke: "#0C66E4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloudBlue);
export default __webpack_public_path__ + "static/media/downloadCloudBlue.3a107e1b1a84074bcfeb4245ccd5c27a.svg";
export { ForwardRef as ReactComponent };